import { Fragment } from 'react';

/**
 * Texte d'un message avec les adresses web cliquables (`https://…`, `http://…`,
 * `www.…`). Seuls http et https deviennent des liens : jamais `javascript:` ni
 * autre schéma. Ouverts dans un nouvel onglet, sans transmettre la page
 * d'origine (`noopener noreferrer`). La ponctuation qui suit une adresse en fin
 * de phrase (« … sur https://exemple.fr. ») reste hors du lien.
 */

const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi;
const TRAILING = /[.,;:!?…»)\]}'"]+$/;

function hrefOf(raw: string): string | null {
  const withScheme = /^www\./i.test(raw) ? `https://${raw}` : raw;
  try {
    const u = new URL(withScheme);
    return u.protocol === 'http:' || u.protocol === 'https:' ? u.href : null;
  } catch {
    return null;
  }
}

export function LinkifiedText({ text }: { text: string }) {
  const parts: React.ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(URL_RE)) {
    let raw = m[0];
    // Parenthèse fermante gardée si l'adresse en contient une ouvrante (Wikipédia).
    const trail = raw.match(TRAILING)?.[0] ?? '';
    if (trail && !(trail.startsWith(')') && raw.includes('('))) raw = raw.slice(0, -trail.length);
    const href = hrefOf(raw);
    if (!href) continue;
    const start = m.index!;
    if (start > last) parts.push(text.slice(last, start));
    parts.push(
      <a key={start} href={href} target="_blank" rel="noopener noreferrer nofollow" className="pl-msg-link"
        onClick={(e) => e.stopPropagation()}>{raw}</a>,
    );
    last = start + raw.length;
  }
  if (parts.length === 0) return <>{text}</>;
  if (last < text.length) parts.push(text.slice(last));
  return <>{parts.map((p, i) => <Fragment key={i}>{p}</Fragment>)}</>;
}
